import {createSlice} from "@reduxjs/toolkit";
import {
    addUISettingsToSurveyQuestions,
    defaultQuestion,
    defaultSurvey,
    isSurveyEditRestricted
} from "../utils/SurveyUtils";
import {validateQuestion} from "../utils/SurveyValidationUtils";

const surveyEditorSlice = createSlice({
    name: 'survey',
    initialState: defaultSurvey,
    reducers: {
        changeSurvey: (state, action) => {
            return action.payload;
        },
        changeSurveyId: (state, action) => {
            return {
                ...state,
                id: action.payload
            }
        },
        changeSurveyTitle: (state, action) => {
            return {
                ...state,
                title: action.payload
            }
        },
        addQuestionToSurveyAtIdx: (state, action) => {
            return {
                ...state,
                questions: [
                    ...state.questions.slice(0, action.payload.insertAtIndex),
                    action.payload.questionData,
                    ...state.questions.slice(action.payload.insertAtIndex)
                ]
            }
        },
        removeQuestionFromSurveyAtIdx: (state, action) => {
            return {
                ...state,
                questions: [
                    ...state.questions.slice(0, action.payload.idx),
                    ...state.questions.slice(action.payload.idx + 1)
                ]
            }
        },
        updateQuestionInSurveyAtIdx: (state, action) => {
            const idx = action.payload.idx;
            const newQuestionData = action.payload.questionData;
            const questions = Array.from(state.questions);
            questions[idx] = newQuestionData;

            return {
                ...state,
                questions: questions
            }
        },
        addSkipGroupToQuestionAtIdx: (state, action) => {
            const questionIndex = action.payload.idx;
            const skipQuestionData = action.payload.skipQuestionData;
            const skipValuesArray = action.payload.skipValuesArray;
            const question = state.questions[questionIndex];
            question.skipGroup = [
                {
                    "skipArray": [
                        {
                            "question_id": skipQuestionData.id,
                            "skipQtype": "multipleChoice",
                            "variableToEval": "answers",
                            "condition": "containsNone",
                            "value": skipValuesArray
                        }
                    ],
                    "operator": "and"
                }
            ];
        },
        removeSkipGroupFromQuestionAtIdx: (state, action) => {
            const questionIndex = action.payload.idx;
            const question = state.questions[questionIndex];
            delete question.skipGroup;
        },
        changeQuestionTab: (state, action) => {
            const questionIndex = action.payload.idx;
            const question = state.questions[questionIndex];
            question.selectedTab = action.payload.tab;
        }
    }
});

export const addNewQuestionAtIdx = (idx, questionQId) => (dispatch) => {
    let newQuestionData = JSON.parse(JSON.stringify(defaultQuestion));
    newQuestionData.id = questionQId;
    dispatch(addQuestionToSurveyAtIdx({insertAtIndex: idx, questionData: newQuestionData}))
};

export const validateQuestionAtIndex = (idx, questionData) => (dispatch) => {
    questionData = JSON.parse(JSON.stringify(questionData));
    questionData.isInvalidQuestion = !validateQuestion(questionData);
    dispatch(updateQuestionInSurveyAtIdx({idx: idx, questionData: questionData}));
    return questionData.isInvalidQuestion;
};

export const isSurveyEditRestrictedSelector = (state) => {
    return isSurveyEditRestricted(state.survey);
};

export const activateEditModeAtIndex = (idx, questionData) => (dispatch) => {
    questionData = JSON.parse(JSON.stringify(questionData));
    questionData.editMode = true;
    dispatch(updateQuestionInSurveyAtIdx({idx: idx, questionData: questionData}));
};

export const {
    changeSurvey,
    changeSurveyId,
    changeSurveyTitle,
    addQuestionToSurveyAtIdx,
    removeQuestionFromSurveyAtIdx,
    updateQuestionInSurveyAtIdx,
    addSkipGroupToQuestionAtIdx,
    removeSkipGroupFromQuestionAtIdx,
    changeQuestionTab
} = surveyEditorSlice.actions;
export default surveyEditorSlice.reducer;